import { useTranslation } from 'react-i18next';
import { useTheme } from '@/shared/ui/theme/ThemeProvider';

/**
 * Small floating tooltip shown on `ScanningPage` when the active AccessRole has
 * zero seeded facial embeddings AND the empty-attempt poll cap has been reached.
 *
 * Design intent: NOT a full-screen overlay — the tooltip sits inline in the page
 * layout so `AuthMethodSwitcher` (PIN / Card) remains fully reachable while the
 * operator sees why facial auth is unavailable.
 *
 * Spec: scan-embeddings-fallback / Non-Blocking Empty-Set Tooltip.
 */
export function EmbeddingsUnavailableTooltip() {
  const { t } = useTranslation('common');
  const { C, T } = useTheme();

  return (
    <div
      data-testid="embeddings-unavailable-tooltip"
      role="status"
      aria-live="polite"
      style={{
        display:       'inline-flex',
        alignItems:    'center',
        gap:           8,
        marginTop:     12,
        marginBottom:  12,
        maxWidth:      420,
        padding:       '9px 16px',
        borderRadius:  20,
        background:    `${C.primary}18`,
        border:        `1px solid ${C.primary}40`,
        color:         C.primary,
        fontSize:      11,
        fontWeight:    600,
        letterSpacing: '.01em',
        textAlign:     'center',
        boxShadow:     `0 4px 12px ${T.border}`,
      }}
    >
      <svg width={12} height={12} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <span>{t('scan.noFacialEnrollmentsTooltip')}</span>
    </div>
  );
}
